var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showPlaceholder)?_c('img',{attrs:{"src":_vm.displayedSrc,"alt":`tournament-${_vm.tournamentId}`},on:{"error":_vm.onError}}):_c('v-icon',{attrs:{"size":_vm.iconSize,"color":_vm.iconColor}},[_vm._v(" mdi-trophy-variant-outline ")])
}
var staticRenderFns = []

export { render, staticRenderFns }